import type { IGetTopArticlesBlock } from '@jtnews/shared/seedwork/frontend/application';

import { NewsClient } from '../../news-client';
import type { IAppNewsClient } from '../../news-client';

import type { TopArticlesBlockLazyDTO } from './top-articles-block.dto';

type TopArticlesBlockApiConfig = {
  deps: {
    client: IAppNewsClient;
  };
};

export type TopArticlesBlockApiInput = {
  regionId: number;
  retry?: {
    maxTry: number;
    delay?: number;
  };
};

export class TopArticlesBlockApi
  extends NewsClient
  implements IGetTopArticlesBlock<TopArticlesBlockLazyDTO>
{
  static readonly TOP_ARTICLES_BLOCK_URL = '/public/jtnews/services/top_news/';

  constructor(config: TopArticlesBlockApiConfig) {
    super(config);
  }

  async get(input: TopArticlesBlockApiInput) {
    const { regionId, retry } = input;

    const { data, responseTime: duration } =
      await this.client.get<TopArticlesBlockLazyDTO>(
        regionId,
        TopArticlesBlockApi.TOP_ARTICLES_BLOCK_URL,
        { retry },
      );

    return {
      data,
      duration,
    };
  }
}
